/*export const popupData = {
    isActive: true,
    type: "image",
    content: "/images/popup.png?text=BPKAD+Kota+Magelang",
    title: "Selamat Datang di BPKAD Kota Magelang",
    description: "Layanan Terpadu Pengelolaan Keuangan dan Aset Daerah"
};*/

export const sliderData = [
    {
        id: 1,
        title: "Pengelolaan Keuangan Daerah yang Transparan",
        description: "Mewujudkan tata kelola keuangan daerah yang akuntabel dan transparan",
        image: "/images/home2.jpg?text=Slide+1"
    },
    {
        id: 2,
        title: "Pelayanan Aset Daerah Terpadu",
        description: "Optimalisasi pengelolaan aset daerah untuk kesejahteraan masyarakat",
        image: "/images/home3.jpg?text=Slide+2"
    },
    {
        id: 3,
        title: "Inovasi Layanan Digital",
        description: "Mempermudah akses layanan melalui transformasi digital",
        image: "/images/home1.jpg?text=Slide+3"
    }
];

export const informasiCards = [
    {
        id: 1,
        title: "Tata Kelola Terjaga",
        description: "Pengelolaan keuangan dan aset daerah yang profesional dan akuntabel",
        icon: "🛡️"
    },
    {
        id: 2,
        title: "Layanan Lebih Terarah",
        description: "Pelayanan yang fokus pada kebutuhan masyarakat dan stakeholder",
        icon: "🎯"
    },
    {
        id: 3,
        title: "Transparansi Publik",
        description: "Keterbukaan informasi publik dalam pengelolaan keuangan daerah",
        icon: "👁️"
    },
    {
        id: 4,
        title: "Kanal Konsultasi Resmi",
        description: "Layanan konsultasi dan pengaduan resmi BPKAD Kota Magelang",
        icon: "💬"
    }
];

export const layananUtama = [
    {
        id: 1,
        title: "Pajak Daerah",
        description: "Pembayaran Pajak Daerah secara Online",
        icon: "📄",
        link: "https://pajakdaerah.magelangkota.go.id"
    },
    {
        id: 2,
        title: "Retribusi",
        description: "Pembayaran Retribusi Daerah secara Online",
        icon: "🏢",
        link: "https://eretda.magelangkota.go.id"
    },
    {
        id: 3,
        title: "E-Retribusi",
        description: "Sistem Pembayaran Retribusi Online",
        icon: "📋",
        link: "http://si-retro.magelangkota.go.id/login"
    },
    {
        id: 4,
        title: "Peta Zona Magelang",
        description: "Peta Interaktif Zona Kota Magelang",
        icon: "🗺️",
        link: "https://znt.magelangkota.go.id/"
    }
];

export const panduanLayanan = [
    {
        id: 1,
        title: "Temukan Layanan Anda",
        steps: [
            "Pilih jenis layanan yang dibutuhkan",
            "Siapkan dokumen persyaratan",
            "Ajukan permohonan secara online",
            "Pantau status permohonan Anda"
        ],
        link: "/panduan/temukan-layanan"
    },
    {
        id: 2,
        title: "Hubungi Kontak Pelayanan",
        contacts: [
            { type: "phone", value: "(0293) 123456" },
            { type: "email", value: "bpkad@magelangkota.go.id" },
            { type: "address", value: "Jl. Jend. Sudirman No. 10, Magelang" }
        ],
        link: "/panduan/kontak-pelayanan"
    }
];

export const layananPenunjang = [
    {
        id: 1,
        title: "Sewa Gedung",
        description: "Pemesanan dan sewa gedung milik Pemkot Magelang",
        icon: "🏠",
        link: "/layanan/sewa-gedung"
    },
    {
        id: 2,
        title: "Surat Keterangan",
        description: "Pengurusan surat keterangan terkait aset daerah",
        icon: "📝",
        link: "/layanan/surat-keterangan"
    },
    {
        id: 3,
        title: "Sewa Aset Kosong",
        description: "Pemanfaatan aset daerah yang belum digunakan",
        icon: "📦",
        link: "/layanan/sewa-aset-kosong"
    },
    {
        id: 4,
        title: "Pusat Bantuan",
        description: "Bantuan dan FAQ seputar layanan BPKAD",
        icon: "🆘",
        link: "/layanan/pusat-bantuan"
    }
];

export const agendaTerkini = [
    {
        id: 1,
        image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&h=400&fit=crop',
        title: 'Rapat Koordinasi Persiapan APBD 2027',
        category: 'Rapat',
        date: '15 Juli 2026',
        time: '09:00 - 12:00 WIB',
        location: 'Ruang Rapat Utama, Gedung BPKAD',
        summary: 'Rapat koordinasi antar bidang dalam rangka penyusunan dan pembahasan Rancangan APBD tahun anggaran 2027.',
        content: `<p>Rapat koordinasi ini dihadiri oleh seluruh Kepala Bidang di lingkungan BPKAD Kota Magelang. Agenda utama adalah membahas mekanisme penyusunan APBD 2027 yang lebih partisipatif dan transparan.</p>
                  <p>Beberapa poin yang dibahas antara lain:</p>
                  <ul>
                    <li>Perubahan regulasi terkait belanja daerah</li>
                    <li>Penyusunan rencana kerja dan anggaran SKPD</li>
                    <li>Evaluasi realisasi APBD 2026</li>
                  </ul>
                  <p>Diharapkan dengan koordinasi ini, APBD 2027 dapat disusun tepat waktu dan sesuai dengan kebutuhan masyarakat Kota Magelang.</p>`,
        pic: 'Drs. Agus Santoso, M.M. (Kepala BPKAD)',
        documents: [
            { name: 'Notulen Rapat', url: '/docs/notulen-rapat-2027.pdf' },
            { name: 'Paparan Materi', url: '/docs/paparan-apbd-2027.pdf' }
        ]
    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=400&fit=crop',
        title: 'Sosialisasi Pengelolaan Keuangan Daerah',
        category: 'Sosialisasi',
        date: '20 Juli 2026',
        time: '08:30 - 15:00 WIB',
        location: 'Aula Kantor Wali Kota Magelang',
        summary: 'Sosialisasi tata kelola keuangan daerah yang transparan dan akuntabel bagi seluruh perangkat daerah di Kota Magelang.',
        content: `<p>Kegiatan sosialisasi ini bertujuan untuk meningkatkan pemahaman seluruh perangkat daerah mengenai tata kelola keuangan yang transparan dan akuntabel berdasarkan peraturan terbaru.</p>
                  <p>Materi yang disampaikan meliputi:</p>
                  <ul>
                    <li>Prinsip-prinsip pengelolaan keuangan daerah</li>
                    <li>Mekanisme pelaporan dan pertanggungjawaban</li>
                    <li>Penggunaan aplikasi SIPD (Sistem Informasi Pemerintahan Daerah)</li>
                  </ul>
                  <p>Peserta berasal dari seluruh OPD di lingkungan Pemerintah Kota Magelang.</p>`,
        pic: 'Dra. Siti Rahayu, M.Si.',
        documents: [
            { name: 'Materi Sosialisasi', url: '/docs/materi-sosialisasi.pdf' }
        ]
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=400&fit=crop',
        title: 'Audit Tahunan BPK atas Laporan Keuangan 2026',
        category: 'Audit',
        date: '5 Juli 2026',
        time: '09:00 - 16:00 WIB',
        location: 'Ruang Rapat BPKAD',
        summary: 'Pelaksanaan audit tahunan oleh Badan Pemeriksa Keuangan (BPK) terhadap laporan keuangan Pemerintah Kota Magelang tahun anggaran 2026.',
        content: `<p>Audit tahunan BPK merupakan bagian dari siklus pengawasan eksternal terhadap pengelolaan keuangan daerah. Proses audit berlangsung selama 2 minggu dengan memeriksa seluruh dokumen keuangan dan bukti transaksi.</p>
                  <p>Tim audit dari BPK Perwakilan Jawa Tengah akan melakukan verifikasi lapangan dan wawancara dengan pejabat terkait.</p>`,
        pic: 'Tim Audit BPK Perwakilan Jawa Tengah'
    }
];

export const beritaTerkini = [
    {
        id: 1,
        image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=400&fit=crop',
        title: 'BPKAD Kota Magelang Raih Predikat WTP Keenam Kalinya',
        category: 'Prestasi',
        date: '12 Juli 2026',
        author: 'Tim Humas BPKAD',
        summary: 'BPKAD Kota Magelang kembali meraih predikat Wajar Tanpa Pengecualian (WTP) dari BPK atas Laporan Keuangan Daerah tahun 2025.',
        content: `<p>Badan Pemeriksa Keuangan (BPK) Perwakilan Provinsi Jawa Tengah menyerahkan Opini WTP kepada Pemerintah Kota Magelang atas Laporan Keuangan Daerah tahun anggaran 2025. Penghargaan ini diterima langsung oleh Kepala BPKAD Kota Magelang, Drs. Agus Santoso, M.M., dalam acara serah terima laporan hasil pemeriksaan di kantor BPK Jateng.</p>
                  <p>Predikat WTP ini merupakan yang keenam kalinya secara berturut-turut diraih oleh Kota Magelang, menunjukkan konsistensi dalam pengelolaan keuangan daerah yang transparan, akuntabel, dan sesuai dengan standar akuntansi pemerintahan.</p>
                  <p>Kepala BPKAD menyampaikan bahwa capaian ini tidak terlepas dari kerja keras seluruh jajaran dan komitmen bersama untuk terus meningkatkan kualitas tata kelola keuangan. Ke depan, BPKAD akan terus berinovasi dan memperkuat sistem pengendalian internal agar predikat WTP dapat dipertahankan.</p>`,
        gallery: [
            '/images/galeri-wtp-1.jpg',
            '/images/galeri-wtp-2.jpg',
            '/images/galeri-wtp-3.jpg'
        ]
    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&h=400&fit=crop',
        title: 'BPKAD Luncurkan Aplikasi E-Budgeting untuk Perencanaan Anggaran',
        category: 'Inovasi',
        date: '8 Juli 2026',
        author: 'Tim IT BPKAD',
        summary: 'Aplikasi E-Budgeting resmi diluncurkan untuk memudahkan perencanaan dan penganggaran di lingkungan Pemerintah Kota Magelang.',
        content: `<p>Dalam upaya mendigitalisasi pengelolaan keuangan daerah, BPKAD Kota Magelang meluncurkan aplikasi E-Budgeting. Aplikasi ini berbasis web dan dapat diakses oleh seluruh perangkat daerah untuk menyusun rencana kerja dan anggaran secara terintegrasi.</p>
                  <p>E-Budgeting memungkinkan proses perencanaan anggaran menjadi lebih transparan, efisien, dan mudah dipantau. Fitur unggulan meliputi penyusunan RKA, KUA, dan PPAS secara online, serta validasi otomatis untuk menghindari kesalahan input.</p>
                  <p>Kepala BPKAD menargetkan seluruh SKPD sudah menggunakan E-Budgeting mulai tahun anggaran 2027. Pelatihan intensif akan diberikan kepada operator dan bendahara di setiap perangkat daerah.</p>`,
        gallery: [
            '/images/galeri-ebudget-1.jpg',
            '/images/galeri-ebudget-2.jpg'
        ]
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop',
        title: 'BPKAD Gelar Sosialisasi Pengelolaan Dana Desa',
        category: 'Sosialisasi',
        date: '5 Juli 2026',
        author: 'Tim Pemberdayaan Masyarakat',
        summary: 'Kegiatan sosialisasi pengelolaan dana desa dilaksanakan untuk meningkatkan kapasitas perangkat desa di seluruh Kecamatan Kota Magelang.',
        content: `<p>BPKAD bersama Dinas Pemberdayaan Masyarakat dan Desa (DPMD) menggelar sosialisasi tentang pengelolaan dana desa yang akuntabel dan sesuai regulasi. Acara diikuti oleh kepala desa, sekretaris desa, dan pendamping desa dari seluruh kecamatan di Kota Magelang.</p>
                  <p>Materi yang disampaikan meliputi mekanisme pengusulan, penggunaan, pelaporan, hingga pertanggungjawaban dana desa. Ditekankan pentingnya transparansi publik melalui papan informasi dan laporan berkala kepada masyarakat.</p>
                  <p>Kegiatan ini diharapkan mampu mencegah potensi penyimpangan dan meningkatkan kesejahteraan masyarakat melalui pemanfaatan dana desa yang tepat sasaran.</p>`,
        gallery: [
            '/images/galeri-dana-desa-1.jpg'
        ]
    }
];

export const dokumentasiKegiatan = [
    {
        id: 1,
        type: "image",
        title: "Rapat Koordinasi Pengelolaan Aset BPKAD Kota Magelang",
        url: "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=600&h=400&fit=crop",
        thumbnail: "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=600&h=400&fit=crop",
        date: "14 Januari 2026",
        description: "Rapat koordinasi antar bidang dalam rangka optimalisasi pengelolaan aset daerah."
    },
    {
        id: 2,
        type: "video",
        title: "Launching Aplikasi e-Retribusi dan e-Pajak Daerah",
        url: "https://www.youtube.com/embed/uCqVTnj-tJA",
        thumbnail: "https://img.youtube.com/vi/uCqVTnj-tJA/maxresdefault.jpg",
        date: "13 Januari 2026",
        description: "Peluncuran resmi aplikasi e-Retribusi dan e-Pajak untuk memudahkan pelayanan pajak daerah."
    },
    {
        id: 3,
        type: "image",
        title: "Penandatanganan MoU dengan Stakeholder",
        url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&h=400&fit=crop",
        thumbnail: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&h=400&fit=crop",
        date: "12 Januari 2026",
        description: "Penandatanganan nota kesepahaman dengan berbagai stakeholder untuk peningkatan pelayanan."
    },
    {
        id: 4,
        type: "image",
        title: "Sosialisasi APBD 2026 kepada Masyarakat",
        url: "https://images.unsplash.com/photo-1557425955-d9d5a5f8f4b4?w=600&h=400&fit=crop",
        thumbnail: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&h=400&fit=crop",
        date: "10 Januari 2026",
        description: "Kegiatan sosialisasi APBD 2026 kepada masyarakat di Aula Kantor Wali Kota Magelang."
    },
    {
        id: 5,
        type: "image",
        title: "Audit Tahunan BPK atas Laporan Keuangan 2025",
        url: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop",
        thumbnail: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop",
        date: "8 Januari 2026",
        description: "Pelaksanaan audit tahunan oleh Badan Pemeriksa Keuangan (BPK) terhadap laporan keuangan tahun anggaran 2025."
    },
    {
        id: 6,
        type: "video",
        title: "Workshop Transparansi Keuangan Daerah",
        url: "https://www.youtube.com/embed/uCqVTnj-tJA",
        thumbnail: "https://img.youtube.com/vi/uCqVTnj-tJA/maxresdefault.jpg",
        date: "5 Januari 2026",
        description: "Workshop peningkatan transparansi dan akuntabilitas keuangan daerah untuk seluruh SKPD."
    }
];

export const jejaringInstansi = [
    {
        id: 1,
        name: "Kementerian Keuangan RI",
        logo: "https://media.kemenkeu.go.id/getmedia/dce5d80f-c267-48af-9181-b5db5f3910e6/logo-atas.png?width=1920&height=483&ext=.png",
        link: "https://kemenkeu.go.id"
    },
    {
        id: 2,
        name: "Pemkot Magelang",
        logo: "https://www.magelangkota.go.id/lambang-header-desktop.svg",
        link: "https://magelangkota.go.id"
    },
    {
        id: 3,
        name: "BAPENDA Provinsi Jawa Tengah",
        logo: "https://website.bapenda.jatengprov.go.id/portal/img/logo-bapenda.png",
        link: "https://bapenda.jatengprov.go.id/"
    },
    {
        id: 4,
        name: "PT. PLN (Persero) ULP Magelang Kota",
        logo: "https://www.pln.co.id/_pln/pln.DN9ikc4e.png",
        link: "https://www.pln.co.id"
    },
    {
        id: 5,
        name: "Kantor Pertanahan Kota Magelang",
        logo: "https://kot-magelang.atrbpn.go.id/img/favicon/favicon.png",
        link: "https://kot-magelang.atrbpn.go.id/"
    },
    {
        id: 6,
        name: "KPP Pratama Magelang",
        logo: "https://www.pajak.go.id/sites/default/files/LogoDJP11%20%281%29.png",
        link: "https://kpppratamamagelang.com"
    },
    {
        id: 7,
        name: "Bank Jateng Kancab Kota Magelang",
        logo: "https://www.bankjateng.co.id/media/Logo_Bank_Jateng_Putih_Transparan.png",
        link: "https://bankjateng.co.id/"
    }
];

export const popupData = {
    isActive: true,
    type: 'youtube',
    content: 'https://www.youtube.com/watch?v=uCqVTnj-tJA', // atau embed URL
    title: '',
    subtitle: '',
    buttons: [
        { label: '', link: '' },
    ],
    extra: {
        instagram: '@bpkadkotamagelang',
        instagramLink: 'https://www.instagram.com/bpkadkotamagelang',
        sambutan: ''
    }
};

export const instagramPosts = [
    {
        id: 1,
        image: "https://placehold.co/400x400/0F4C3A/FFFFFF?text=Postingan+1",
        caption: "Sosialisasi e-Retribusi",
        likes: 128,
        comments: 15,
    },
    {
        id: 2,
        image: "https://placehold.co/400x400/2E7D32/FFFFFF?text=Postingan+2",
        caption: "Pelatihan Pengelolaan Aset",
        likes: 95,
        comments: 8,
    },
    {
        id: 3,
        image: "https://placehold.co/400x400/4CAF50/FFFFFF?text=Postingan+3",
        caption: "Rapat Koordinasi APBD",
        likes: 112,
        comments: 20,
    },
    {
        id: 4,
        image: "https://placehold.co/400x400/1B5E20/FFFFFF?text=Postingan+4",
        caption: "Launching Aplikasi Baru",
        likes: 203,
        comments: 32,
    },
    {
        id: 5,
        image: "https://placehold.co/400x400/388E3C/FFFFFF?text=Postingan+5",
        caption: "Penghargaan WTP",
        likes: 250,
        comments: 45,
    },
    {
        id: 6,
        image: "https://placehold.co/400x400/81C784/FFFFFF?text=Postingan+6",
        caption: "Kegiatan Bakti Sosial",
        likes: 87,
        comments: 10,
    },
];